export class KryptonEventDetail {
    static CLICK: String = "click";
    static EXPAND: String = "expand";
    static COLLAPSE: String = "collapse";
    static SHOW: String = "show";
    static HIDE: String = "hide";
    static DISMISS: String = "dismiss";
    static CONNECTED: String = "connected";
    static NAV: String = "nav";
    static SELECTED: String = "selected";

    static MENU_ITEM_EVENT: string = "menu-item-event";
    static SHOW_PAGE_COMPLETED_EVENT: string = "show-page-completed-event";
    static HIDE_PAGE_COMPLETED_EVENT: string = "hide-page-completed-event";

    static PAGE_ELEMENT_CONNECTED: string = "page-element-connected";
    static PAGE_NAV_EVENT: string = "page-nav-event";
    static TABLE_EVENT: string = "table-event";

    static NOTIFICATION_ELEMENT_EVENT: string = "notification-element-event";
    static NOTIFICATION_SHOW_HIDE_EVENT: string = "notification-show-hide-event";

    // Event attributes
    private type: String;
    private name: string;
    private properties: any;

    constructor(type: String, name: string, properties: any) {
        this.type = type;
        this.name = name;
        this.properties = properties;
    }
    isMenuItemClick() {
        return (this.type === KryptonEventDetail.CLICK && this.name === KryptonEventDetail.MENU_ITEM_EVENT);
    }
    getProperties() {
        return this.properties;
    }
    getType() {
        return this.type;
    }
    getName() {
        return this.name;
    }
}
